var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasPermissionView)?_c('div',{staticClass:"animated fadeIn"},[_c('rate-plan-list-filter',{attrs:{"unit_id":_vm.unit_id}}),_c('rate-plan-list-table',{attrs:{"unit_id":_vm.unit_id}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }